import type { AddFilterTippyInstance, GlobalFilter } from '@hotjar/global-filters';
import { FilterKindEnum } from '@hotjar/global-filters';
import {
  MAX_DATA_RETENTION_PERIOD,
  StatefulFilterChain,
} from '@hotjar/webapp/features/GlobalFilterChain/StatefulComponent/StatefulFilterChain';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';
import type { Segment } from '../types';

const Container = styled.div`
  padding-bottom: ${tokens.spacer.x3};
  display: flex;
  width: 100%;
`;

const SUPPORTED_FILTER_LIST: Set<FilterKindEnum> = new Set([
  FilterKindEnum.Error,
  FilterKindEnum.Clicked,
  FilterKindEnum.VisitedURL,
  FilterKindEnum.ReferrerURL,
  FilterKindEnum.LandingURL,
  FilterKindEnum.ExitURL,
  FilterKindEnum.NewReturningUserKind,
  FilterKindEnum.Country,
  FilterKindEnum.Event,
  FilterKindEnum.GoogleOptimize,
  FilterKindEnum.Optimizely,
  FilterKindEnum.Unbounce,
  FilterKindEnum.UserAttribute,
  FilterKindEnum.SessionDuration,
  FilterKindEnum.PageCount,
  FilterKindEnum.RageClickKind,
  FilterKindEnum.UTurnKind,
  FilterKindEnum.TeamComment,
  FilterKindEnum.UserID,
  FilterKindEnum.DeviceType,
  FilterKindEnum.Browser,
  FilterKindEnum.OS,
  FilterKindEnum.IncomingFeedback,
  FilterKindEnum.NPS,
]);

export type RecordingFilterChainProps = {
  currentFiltersInUiFormat?: GlobalFilter;
  currentSegment?: Segment;
  segments?: Segment[];
  onChange: (filtersInUiFormat: GlobalFilter, segmentId?: number) => void;
  onSegmentSaved: (segment: Segment) => void;
  onUpsellRequest: (featureName: string) => void;
  setAddFilterTippyInstance?: (tippyInstance: AddFilterTippyInstance | null) => void;
};

export const RecordingFilterChain = ({
  currentFiltersInUiFormat,
  currentSegment,
  segments = [],
  onChange,
  onSegmentSaved,
  onUpsellRequest,
  setAddFilterTippyInstance,
}: RecordingFilterChainProps): JSX.Element => {
  return (
    <Container>
      <StatefulFilterChain
        currentFiltersInUiFormat={currentFiltersInUiFormat}
        currentSegment={currentSegment}
        segments={segments}
        onChange={onChange}
        onSegmentSaved={onSegmentSaved}
        onUpsellRequest={onUpsellRequest}
        setAddFilterTippyInstance={setAddFilterTippyInstance}
        supportedFilterList={SUPPORTED_FILTER_LIST}
        dateConstraint={MAX_DATA_RETENTION_PERIOD}
        contextOfUse={{
          productType: ProductType.Analytics,
          page: 'playbacks.list',
          toolName: 'Recordings',
        }}
      />
    </Container>
  );
};
